import styles from './AddUserIndex.module.scss';
import { Field, Formik, FormikProps } from 'formik';
import { Input } from '../common/Input';
import React, { useRef } from 'react';
import * as yup from 'yup';
import { UserFormData } from '../../apollo/types/UserFormData';


const validationSchema = yup.object().shape({
    name: yup.string().required(),
    emailAddress: yup.string().email().required(),
    language: yup.string().oneOf(['nl', 'en']),
});

type AddUserFormProps = {
    formikRef: React.Ref<FormikProps<UserFormData>>;
    submitValues: Function;
    formData: {
        name?: String,
        emailAddress?: String,
        language?: String,
        userFunction?: String
    }
}

export const AddUserForm = ({
    formikRef,
    submitValues,
    formData
}: AddUserFormProps) => {
    return (
        <Formik
            enableReinitialize
            validationSchema={validationSchema}
            initialValues={formData}
            onSubmit={(values) => {
                submitValues(values)
            }}
            // @ts-ignore
            innerRef={formikRef}
        >
            {({ values, errors, touched, handleChange, handleSubmit, handleBlur, isValid }) => (
                <form className={styles.formContainer} onSubmit={handleSubmit}>
                    <div className={styles.inputContainerHalf}>
                        <div style={{width: '100%'}}>
                            {errors.name && touched.name ? (
                                <span className={styles.error}>Name is required</span>
                            ) : null}
                            <Field
                                id="name"
                                name='name'
                                as={Input}
                                type='text'
                                placeholder='Name'
                                value={values.name}
                            />
                        </div>
                        <div style={{width: '100%'}}>
                            {errors.emailAddress && touched.emailAddress ? (
                                errors.emailAddress.includes('valid')
                                    ? <span className={styles.error}>Email format is incorrect</span>
                                    : <span className={styles.error}>Email address is required</span>
                            ) : null}
                            <Field
                                name='emailAddress'
                                as={Input}
                                type='text'
                                placeholder='Email address'
                                onChange={handleChange}
                                value={values.emailAddress}
                            />
                        </div>
                    </div>
                <div className={styles.inputContainer}>
                    <Field
                        name='userFunction'
                        as={Input}
                        type='text'
                        placeholder='Function'
                        onChange={handleChange}
                        value={values.userFunction}
                    />
                </div>
                <div className={styles.selectContainer}>
                    <Field
                        className={styles.select}
                        name='language'
                        as="select"
                        placeholder='Language'
                        onChange={handleChange}
                        value={values.language}
                    >
                        <option value="nl">Dutch</option>
                        <option value="en">English</option>
                    </Field>
                </div>
                </form>
            )}
        </Formik>
    )
}
